import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/shadcn/select'
import { stateOptionsWithAll } from './stateMap'

export function DataAssetsFilter({ filter, setFilter }: { filter: string; setFilter: (filter: string) => void }) {
  return (
    <Select value={filter} onValueChange={setFilter}>
      <SelectTrigger className="h-7 w-[180px]">
        <SelectValue placeholder="Select a state" />
      </SelectTrigger>
      <SelectContent>
        {stateOptionsWithAll.map((state) => (
          <SelectItem key={state} value={state}>
            {state}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
